import React from 'react';
import {get} from 'lodash';

import {
  useModal,
} from '../hooks';

import ImageLoader from './ImageLoader'
import PostsListImageModal from './PostsListImageModal'

const PostImageModal = ({
  post,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  if (get(post, 'images.length', 0) == 0) {
    return <p className='Placeholder'>No data</p>
  }

  return (
    <div className='Table__images'>
      <div className='Table__images__control'>
        <a
          className='Table__images__control__a'
          onClick={onToggleModal}
        >
          Remove
        </a>

        <PostsListImageModal
          isActive={modal}
          onToggleModal={onToggleModal}
          post={post}
          $submitButton={$submitButton}
        />
      </div>

      <div className='Table__images__wrapper'>
        {get(post, 'images', []).map((image, i) => (
          <div className='ImageBorder ImageBorder--square' key={i}>
            <ImageLoader
              renderAsImg
              url={get(image, 'url')}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PostImageModal;
